// extracted by mini-css-extract-plugin
export default {"textBlock":"TextBlock-module--textBlock--KYanF","textBlock__content":"TextBlock-module--textBlock__content--qTu8+","textBlock__text":"TextBlock-module--textBlock__text--kcef-"};